import { useDispatch } from "react-redux";
import { setFavoriteList } from "@/src/store/favorite";
import { fetchAllFavoriteLists } from "services/favorites";

export const favoriteHelpers = () => {
  const dispatch = useDispatch();

  const getAllFavoritesByAccount = async (successCallback) => {
    try {
      const response = await fetchAllFavoriteLists();
      if (response.status === "success") {
        const {
          result: { favoriteListV2ResponseList },
        } = response;
        dispatch(setFavoriteList(favoriteListV2ResponseList));
        successCallback && successCallback(favoriteListV2ResponseList);
      }
    } catch (error) {
      dispatch(setFavoriteList([]));
      console.error(`Favorite Fetch Error!! ${error}`);
    }
  };

  return getAllFavoritesByAccount;
};
